// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrum-wrapper {
  display: flex;
  align-items: center;
  justify-content: left;
}
.breadcrum-wrapper .breadcrum-item {
  cursor: pointer;
}
.breadcrum-wrapper .breadcrum-item:nth-child(1) .breadcrum-seperator-icon {
  color: #003da5;
}
.breadcrum-wrapper .breadcrum-item .p-menuitem-text {
  color: #003da5;
  font-size: 1rem;
  font-weight: 600;
}
.breadcrum-wrapper .breadcrum-item:nth-last-child(1) .p-menuitem-text {
  color: #003da5;
  font-size: 1rem;
  font-weight: 600;
}
.breadcrum-wrapper .breadcrum-item:nth-last-child(1) .breadcrum-seperator-icon {
  display: none;
}
.breadcrum-wrapper .breadcrum-item.black-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.breadcrum-wrapper .breadcrum-item.black-icon:last-child .p-menuitem-text {
  color: #003da5;
  font-size: 1rem;
  font-weight: 600;
}
.breadcrum-wrapper .breadcrum-item.black-icon:last-child .breadcrum-seperator-icon {
  display: none;
}
.breadcrum-wrapper .breadcrum-item.black-icon:nth-child(1) .p-menuitem-text {
  color: #808080;
  font-weight: 400;
}
.breadcrum-wrapper .breadcrum-item.black-icon:nth-child(1) .breadcrum-seperator-icon {
  color: #595959;
}
.breadcrum-wrapper .breadcrum-item.black-icon:nth-child(2) .p-menuitem-text {
  color: #808080;
  font-weight: 400;
  position: relative;
}
.breadcrum-wrapper .breadcrum-item.black-icon:nth-child(2) .breadcrum-seperator-icon::before {
  position: relative;
}
.breadcrum-wrapper .breadcrum-item.rework-input {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.breadcrum-wrapper .breadcrum-item.rework-input:last-child .p-menuitem-text {
  font-size: 1rem;
  font-weight: 600;
  color: #003da5;
  position: relative;
}
.breadcrum-wrapper .breadcrum-item.rework-input:last-child .breadcrum-seperator-icon {
  display: none;
}
.breadcrum-wrapper .breadcrum-item.rework-input:nth-child(1) .p-menuitem-text {
  color: #808080;
  font-weight: 400;
}
.breadcrum-wrapper .breadcrum-item.rework-input:nth-child(1) .breadcrum-seperator-icon {
  color: #595959;
}`, "",{"version":3,"sources":["webpack://./src/components/common/CustomBreadcrum/index.scss"],"names":[],"mappings":"AAMA;EACG,aAAA;EACA,mBAAA;EACA,qBAAA;AALH;AAOE;EACE,eAAA;AALJ;AAQM;EACE,cAhBM;AAUd;AAUI;EACE,cArBQ;EAsBR,eAAA;EACA,gBApBa;AAYnB;AAYM;EACE,cA5BM;EA6BN,eAAA;EACA,gBA3BW;AAiBnB;AAYM;EACE,aAAA;AAVR;AAeE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AAbJ;AAgBM;EACE,cA7CM;EA8CN,eAAA;EACA,gBA5CW;AA8BnB;AAgBM;EACE,aAAA;AAdR;AAmBM;EACE,cAvDI;EAwDJ,gBArDY;AAoCpB;AAmBM;EACE,cA1DW;AAyCnB;AAsBM;EACE,cAjEI;EAkEJ,gBA/DY;EAgEZ,kBAAA;AApBR;AAwBQ;EACE,kBAAA;AAtBV;AA4BE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AA1BJ;AA6BM;EACE,eAAA;EACA,gBApFW;EAqFX,cAxFM;EAyFN,kBAAA;AA3BR;AA8BM;EACE,aAAA;AA5BR;AAiCM;EACE,cAlGI;EAmGJ,gBAhGY;AAiEpB;AAkCM;EACE,cAtGW;AAsEnB","sourcesContent":["$blue-color : #003da5;\n$dark-grey: #808080;\n$separator-color : #595959;\n$font-weight-bold: 600;\n$font-weight-light: 400;\n\n.breadcrum-wrapper {\n   display: flex;\n   align-items: center;\n   justify-content: left;\n\n  .breadcrum-item {\n    cursor: pointer;\n\n    &:nth-child(1) {\n      .breadcrum-seperator-icon {\n        color: $blue-color;\n      }\n    }\n\n    .p-menuitem-text {\n      color: $blue-color;\n      font-size: 1rem;\n      font-weight: $font-weight-bold;\n    }\n\n    &:nth-last-child(1) {\n      .p-menuitem-text {\n        color: $blue-color;\n        font-size: 1rem;\n        font-weight: $font-weight-bold;\n      }\n      .breadcrum-seperator-icon {\n        display: none;\n      }\n    }\n  }\n\n  .breadcrum-item.black-icon {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n    &:last-child {\n      .p-menuitem-text {\n        color: $blue-color;\n        font-size: 1rem;\n        font-weight: $font-weight-bold;\n      }\n      .breadcrum-seperator-icon {\n        display: none;\n      }\n    }\n\n    &:nth-child(1) {\n      .p-menuitem-text {\n        color:$dark-grey; \n        font-weight:$font-weight-light;\n      }\n      .breadcrum-seperator-icon {\n        color: $separator-color;\n      }\n    }\n\n    &:nth-child(2) {\n      .p-menuitem-text {\n        color:$dark-grey; \n        font-weight:$font-weight-light;\n        position:relative;\n      }\n\n      .breadcrum-seperator-icon {\n        &::before{\n          position: relative;\n        }\n      }\n    }\n  }\n\n  .breadcrum-item.rework-input {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n    &:last-child {\n      .p-menuitem-text {\n        font-size: 1rem;\n        font-weight: $font-weight-bold;\n        color: $blue-color;\n        position: relative;\n      }\n\n      .breadcrum-seperator-icon {\n        display: none;\n      }\n    }\n\n    &:nth-child(1) {\n      .p-menuitem-text {\n        color:$dark-grey; \n        font-weight:$font-weight-light;\n      }\n\n      .breadcrum-seperator-icon {\n        color: $separator-color;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
